import Image from 'next/image'

import { GeneralNoticeState } from 'components/NoticeState'

import type { GeneralNoticeStateProps } from 'components/NoticeState/GeneralNoticeState'
import type { FC, ReactNode } from 'react'

type StateEmptyProps = GeneralNoticeStateProps & {
  children?: ReactNode
}

const StateEmpty: FC<StateEmptyProps> = ({
  children = (
    <>
      Pastikan terdapat pegawai dengan jabatan tersebut di daerah
      <br />
      Anda dan sudah menyelesaikan tahap Perencanaan Kinerja.
    </>
  ),
  title = 'Belum ada data',
  ...props
}) => {
  return (
    <GeneralNoticeState
      {...props}
      containerClassNames="flex flex-col items-center justify-center"
      icon={
        <Image
          src="/illustrations/img-empty-document-2.png"
          alt=""
          width="84"
          height="84"
        />
      }
      titleVariant="heading-sm"
      descriptionVariant="body"
      titleClassNames="!mt-3"
      descriptionClassNames="!mt-1 text-center"
      title={title}
      description={children}
    />
  )
}
export default StateEmpty
